import { LOCAL_STORAGE_USER_LOGIN_INFO, ORDER_BY, ODER_BY_TYPE, ResponseCode } from "@app/constants/Common";
import { EmailInviteMode } from "@app/pages/candidate/list/DVTJCUVEmailInviteModal";
import { Button } from "@components";
import DVTJCUVPipelineTableList, { DVTJCUVPipelineListMode } from "@pages/dvtjcuv/list/DVTJCUVPipelineTableList";
import { requestGetDVTJCUVPipeLineList } from "@pages/dvtjcuv/service/DVTJCUVPipelineService";
import React, { useEffect, useState } from 'react';

const DVTJCUVPipelineNextStragyCompaignGroupItemList = (props) => {
    const [pipelines, setPipelines] = useState([]);
    const [selectedPipelines, setSelectedPipelines] = useState([]);
    const [showFollowUpModal, setShowFollowUpModal] = useState(false);

    const {pipelineIds, nextFUStrategy, nextFUCompaign, parentTab, mode, onEmailFU} = props
    const [userLoginInfo, setUserLoginInfo] = useState({});
    const [sortPipeColumns, setSortPipeColumns] = useState({
        created_date_time: ORDER_BY.DESC_UPDATE_DATE
    });

    const fetchPipelineList = async (ids) => {
        const params = {
            search_conditions: {
                parent_tab: parentTab?.id,
                // sub_tab: subTab?.id,
                pipeline_ids: ids,
                unlimited: true
            },
            sort_columns: sortPipeColumns
        }
        const res = await requestGetDVTJCUVPipeLineList(params);
        if (res.sts_code === ResponseCode.SUCCESS) {
            setPipelines(res.content.pipelines);
        }
    }

    const onEmailFUHandle = async () => {
        onEmailFU(selectedPipelines)
    }


    useEffect(() => {
        let loginUser = {}
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            loginUser = JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO))
            setUserLoginInfo(loginUser)
        }
    }, [])

    useEffect(() => {
        if (pipelineIds && pipelineIds.length > 0) {
            fetchPipelineList(pipelineIds).then()
        }

    }, [pipelineIds]);

    const onSelectItems = (items) => {
        console.log("Select items")
        setSelectedPipelines([...items])
    }

    const onSortPipelines = async (columnKey) => {
        // alert('on sort pipelines:' + JSON.stringify(columnKey))
        let sortColumns = {...sortPipeColumns}
        if (sortColumns[columnKey] && sortColumns[columnKey] === ODER_BY_TYPE.ASC) {
            sortColumns[columnKey] = ODER_BY_TYPE.DESC
        } else {
            sortColumns = {}
            sortColumns[columnKey] = ODER_BY_TYPE.ASC
        }

        setSortPipeColumns(sortColumns)
        await fetchPipelineList(pipelineIds)
    }

    const getBtnEmailFuTitle = () => {
        if (mode === EmailInviteMode.INVITE_EMAIL_INVITE_SEND_JOB_FU) {
            return "Email Mời gửi job (FU)"
        }
        return "Email FU"
    }

    const getNextFUStrategyTitle = () => {
        if (mode === EmailInviteMode.INVITE_EMAIL_INVITE_SEND_JOB_FU) {
            return "(REC) FU Strategy (Next time)"
        }
        return "FU Strategy (Next time)"
    }

    const getNextFUCompaignTitle = () => {
        if (mode === EmailInviteMode.INVITE_EMAIL_INVITE_SEND_JOB_FU) {
            return "(REC) FU Compaign (Next time)"
        }
        return "FU Compaign (Next time)"
    }

    return (
        <>
            <div className='card card-default'>
                <div className='card-header'>
                    <span className='card-title'>
                        {getNextFUStrategyTitle()}: <b>{nextFUStrategy}</b>
                    </span>
                    <div className='card-title ml-5'>
                        {getNextFUCompaignTitle()}: <b>{nextFUCompaign}</b>
                    </div>
                    <div className={'card-tools'}>
                    
                    <Button
                        className={'btn-sm btn-info'}
                        onClick={onEmailFUHandle}
                        disabled={selectedPipelines.length === 0}
                    >
                        {getBtnEmailFuTitle()}
                    </Button>
                    </div>
                </div>
                <div className='card-body p-0'>
                    <DVTJCUVPipelineTableList
                        pipeLines={pipelines}
                        mode={DVTJCUVPipelineListMode.RUN_DVTJCUV_ACQUIRE_CDD}
                        showBtnSelect
                        hideColumns={[]}
                        parentTabId={parentTab.id}
                        // subTabId={currentTab.id}
                        onSelectItems={(items => {
                            onSelectItems(items)
                        })}
                        onEditItem={() => {
                        }}
                        onSort={onSortPipelines}
                        sortColumn={sortPipeColumns}
                    />
                </div>
            </div>
        </>
    )
}

export default DVTJCUVPipelineNextStragyCompaignGroupItemList;
